class _RouterWrapper{
    constructor(Vue,opts = {}){
        this.$router = opts.router
        this.$store = opts.store
        this.$vue = Vue
        console.log("create router wrapper class", this.$router)
        this.$isRouting = false
    }
    replace(obj = {}){
        if(typeof obj === 'string'){

        }


        const currentRoute = this.$router.currentRoute
        const params = Object.assign({},currentRoute.params,obj.params)

        const name = obj.name || currentRoute.name

        const _params = {}
        let query = Object.assign({
        },obj?.query)
        if(name === currentRoute.name){
            query = Object.assign({},currentRoute.query,obj?.query)
        }
        for(let key in query){
            if(query[key] === undefined || query[key] === null){
                delete query[key]
            }
        }

        if(this.$isRouting){
            return
        }

        let f = null

        if(name){
            const resolved = this.$router.resolve({name})
            const target = resolved.route.matched[0]
            //console.warn("target",target.regex?.keys)

            const keys = target?.regex?.keys
            keys.forEach(key=>{
                const keyName = key.name
                if(params[keyName]){
                    _params[keyName] = params[keyName]
                }
            })

            if(name === currentRoute.name){
                //  paramsが同じか調べる
                if(this.isSameParams(_params,currentRoute.params)){
                    if(this.isSameParams(query,currentRoute.query)){
                        // 全く同じなので無視する
                        console.log("same route ",currentRoute.query,query)
                    }
                    else{
                        f = this.$router.replace({name, params: _params, query})
                    }
                }
                else{
                    f = this.$router.replace({name, params: _params, query})
                }
            }
            else {
                f = this.$router.replace({name, params: _params, query})
            }
        }
        else{
            console.log("name is not defined")
        }

        if(f){
            this.$isRouting = true;
            f.then( (r)=>{
            }).finally(() => {
                this.$isRouting = false
            }).catch((err) => {
                if(err.name !== 'NavigationDuplicated') {
                    console.error("route error ", err.name,err)
                }
            })
        }

        //console.log("replace ....",_params,this.$router)

    }
    pushByName(name,opts = {}){

        if(name.startsWith("..")){
            const currentRoute = this.$router.currentRoute
            const paths = currentRoute.name.split('.')
            paths.pop()
            const _name = name.substring(2)
            paths.push(_name)
            const pushName = paths.join('.')

            const route = this.createRouteObjectByName(pushName,opts)
            if(route) {
                this.$router.push(route)
                return
            }
        }
        else if(name.startsWith('.')){
            const currentRoute = this.$router.currentRoute
            console.log("pushName",name,currentRoute)
            return
        }

        const _opts = Object.assign({
            name : name
        },opts)
        this.$router.push(_opts)
    }
    push(obj){
        if(typeof obj === 'string'){
            const currentRoute = this.$router.currentRoute
            console.log("push route .....",obj,currentRoute)
            const resolved = this.$router.resolve(obj)
            console.log("resolved",resolved)
        }
    }

    /**
     * 与えられた
     * @param name
     * @param opts
     */
    createRouteObjectByName(name,opts = {}){
        const resolved = this.$router.resolve({name})
        const target = resolved.route.matched[0]
        const keys = target?.regex?.keys

        const currentRoute = this.$router.currentRoute
        const params = Object.assign({},currentRoute.params,opts?.params)

        const _params = {}
        keys.forEach(key=>{
            const keyName = key.name
            if(params[keyName]){
                _params[keyName] = params[keyName]
            }
        })

        return {
            name : name,
            params : _params,
            query : opts?.query
        }
    }

    isSameParams(params1,params2){
        const keys1 = Object.keys(params1)
        const keys2 = Object.keys(params2)
        if(keys1.length !== keys2.length){
            return false
        }
        for(let i = 0; i < keys1.length; i++){
            const key = keys1[i]
            const val1 = params1[key]
            const val2 = params2[key]
            if(val1 !== val2){
                return false
            }
        }
        return true
    }
}
const RouterWrapper = {
    install(Vue, Router) {
        Vue.prototype.$$router = new _RouterWrapper(Vue,Router)
    }
}
export default RouterWrapper
